<template>
  <h3>Перестрахование</h3>
  <div class="block">
    <p>Для создания расчетов в разделе «Перестрахование» необходимо загрузить файлы «Загрузка для Доли РУ».</p>
    <p>Исходный метод расчета в данном разделе – метод «Цепная лестница». Также доступны методы расчетов Борнхьюттера-Фергюссона и Доля от резерва.</p>
    <h5>Метод «Цепная лестница (ЦЛ)»</h5>
    <p>В методе «ЦЛ» представлена персонализация расчета:</p>
    <p>1. Исключение выбросов в индивидуальных коэффициентах развития доли перестраховщиков в убытках</p>
    <p>Исключение выбросов проводится с помощью нажатия на нужные для удаления коэффициенты.</p>
    <img src="@/assets/img/guide/development-coefficients-re.png" alt="" srcset="">
    <p>2. Выбор коэффициентов развития доли перестраховщиков в убытках</p>
    <p>Пользователь может выбрать коэффициенты из представленных, а также задать их вручную.</p>
    <img src="@/assets/img/guide/development-coefficients-re-selection.png" alt="" srcset="">
    <h5>Метод «Борнхьюттера-Фергюссона (БФ)»</h5>
    <p>В методе «БФ» представлена следующая персонализация расчета:</p>
    <p>1. Выбор метода расчета</p>
    <img src="@/assets/img/guide/bf-method-select-re.png" alt="" srcset="">
    <p>2. Исключение выбросов в индивидуальных коэффициентах развития доли перестраховщиков в убытках:</p>
    <img src="@/assets/img/guide/individual-coef-re.png" alt="" srcset="">
    <p>3. Выбор коэффициентов развития доли перестраховщиков в убытках:</p>
    <img src="@/assets/img/guide/coef-choose-re.png" alt="" srcset="">
    <p>4. Коэффициенты возмещения убытков от перестраховщика - исключение выбросов:</p>
    <img src="@/assets/img/guide/coef-exclude-re.png" alt="" srcset="">
    <p>5. Коэффициенты возмещения убытков от перестраховщика - выбор итоговых коэффициентов:</p>
    <img src="@/assets/img/guide/coef-return-re.png" alt="" srcset="">
    <h5>Метод «Доля от резерва»</h5>
    <p>Если в загрузке по Перестрахованию заполнен лист «Брутто-резервы», доступен метод расчета «Доля от резерва».</p>
    <p>В методе «Доля от резерва доступная следующая персонализация расчетов:</p>
    <p>1. Обнуление отрицательного РПНУ</p>
    <p>В случае отрицательного РПНУ есть возможность его обнулить.</p>
    <img src="@/assets/img/guide/share-method-header-re.png" alt="" srcset="">
    <p>2. Доля перестраховщиков в РЗНУ, %</p>
    <p>При выборе доли изменяются следующие столбцы в таблице «Доля перестраховщиков в РПНУ»:</p>
    <img src="@/assets/img/guide/share-method-arrows-re.png" alt="" srcset="">
  </div>
</template>
  
<script>
export default {
  name: 'Reinsurance',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
